<template>
  <div class="navigation-subnavigation-fi">
    <navigation-products-fi v-if="isProducts" />
    <navigation-companies-fi v-else-if="isCompany" />
    <navigation-items-fi
      v-else
      :key="groupData?.url"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { useNavigationStore } from '@/store/pinia/navigation';

import NavigationCompaniesFi from './navigation-companies-fi/NavigationCompaniesFi.vue';
import NavigationItemsFi from './navigation-items-fi/NavigationItemsFi.vue';
import NavigationProductsFi from './navigation-products-fi/NavigationProductsFi.vue';

defineOptions({ name: 'NavigationSubnavigationFi' });

const navigationStore = useNavigationStore();

const groupData = computed(() => navigationStore.groupData);
const isProducts = computed(() => navigationStore.isProducts);
const isCompany = computed(() => navigationStore.isCompany);
</script>

<style scoped src="./navigation-subnavigation-fi" />
